import { useInfiniteQuery } from "@tanstack/react-query";
import getPoliceProfiles from "../axios/getPoliceProfiles";

const useQueryPoliceProfiles = () => {
  return useInfiniteQuery(
    ["kepolisian_internasional"],
    ({ pageParam = 1 }) => {
      return getPoliceProfiles({ page: pageParam });
    },
    {
      getNextPageParam: (lastPage, allPages) => {
        const policeProfilesList = allPages.flatMap(
          (page) => page.kepolisian_internasional.data,
        );
        if (
          policeProfilesList.length < lastPage.kepolisian_internasional.total
        ) {
          return lastPage.kepolisian_internasional.current_page + 1;
        }
        return undefined;
      },
    },
  );
};

export default useQueryPoliceProfiles;
